import * as React from 'react'

export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
    const [debounced, setDebounced] = React.useState(value)

    React.useEffect(() => {
        const timeout = window.setTimeout(() => setDebounced(value), delayMs)
        return () => window.clearTimeout(timeout)
    }, [value, delayMs])

    return debounced
}
